import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={26} height={26} rx={6} fill="#352A1F" />
    <path
      d="M9.26084 10.189C9.26084 11.0728 8.54453 11.7894 7.66069 11.7894C6.77707 11.7894 6.06055 11.0728 6.06055 10.189C6.06055 9.30539 6.77707 8.58887 7.66069 8.58887C8.54453 8.58887 9.26084 9.30539 9.26084 10.189Z"
      fill="#BC9B6A"
    />
    <path
      d="M21.42 14.8591L18.6532 12.7127C18.4349 12.5433 18.1665 12.4512 17.8902 12.4512C17.614 12.4512 17.3454 12.5433 17.1273 12.7127L13.3035 15.6815C13.0853 15.8508 12.8169 15.943 12.5404 15.943C12.2642 15.943 11.9958 15.8508 11.7775 15.6815L10.6404 14.7908C10.4224 14.6214 10.1538 14.5294 9.87752 14.5294C9.60128 14.5294 9.33292 14.6214 9.11461 14.7908L5.5789 17.5369C5.3039 17.7502 5.13098 18.0691 5.10199 18.4158C5.073 18.7626 5.19042 19.1056 5.42607 19.3617C5.66173 19.6179 5.99369 19.7635 6.34177 19.7635H20.6569C20.9868 19.7635 21.3032 19.6324 21.5366 19.3992C21.7698 19.1658 21.9009 18.8494 21.9009 18.5195V15.8299C21.8973 15.4497 21.7201 15.0923 21.4198 14.8592L21.42 14.8591Z"
      fill="#BC9B6A"
    />
    <path
      d="M21.1683 6H5.83166C5.34584 6 4.87991 6.193 4.53655 6.53655C4.19299 6.8801 4 7.34606 4 7.83187V19.077C4 19.5628 4.193 20.0288 4.53655 20.3723C4.87989 20.7159 5.34584 20.9089 5.83166 20.9089H21.1683C21.6542 20.9089 22.1201 20.7159 22.4635 20.3723C22.807 20.0288 23 19.5628 23 19.077V7.83187C23 7.34605 22.807 6.88012 22.4635 6.53655C22.1201 6.19299 21.6542 6 21.1683 6ZM22.4063 19.0773C22.4063 19.4057 22.2758 19.7205 22.0437 19.9528C21.8116 20.185 21.4966 20.3152 21.1684 20.3152H5.83167C5.50344 20.3152 5.18846 20.185 4.95631 19.9528C4.72417 19.7205 4.59372 19.4057 4.59372 19.0773V7.83213C4.59372 7.5037 4.72417 7.18892 4.95631 6.95657C5.18845 6.72443 5.50341 6.59418 5.83167 6.59418H21.1684C21.4966 6.59418 21.8116 6.72443 22.0437 6.95657C22.2758 7.18891 22.4063 7.50366 22.4063 7.83213V19.0773Z"
      fill="#BC9B6A"
    />
  </svg>
);
export default SVGComponent;
